import type { ReactNode } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { PageHeaderLeading } from '@/components/navigation/page-header-leading'
import { PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'

import { canvasPagePath, getPluginSlots } from './slots'
import type { PluginAppRoute, PluginCanvasManifest } from './types'

function PluginCanvasPage({ manifest }: { manifest: PluginCanvasManifest }) {
  const params = useParams() as Record<string, string>
  const navigate = useNavigate()
  const Render = manifest.render
  return (
    <PageContainer>
      <PageHeader leading={<PageHeaderLeading />} title={manifest.title} description={manifest.description} />
      <Render
        canvasId={manifest.id}
        mode="page"
        params={params}
        entity={null}
        pagePath={canvasPagePath(manifest, params)}
        close={() => navigate(-1)}
      />
    </PageContainer>
  )
}

const pageElements = new WeakMap<PluginCanvasManifest, () => ReactNode>()

function pageElement(manifest: PluginCanvasManifest) {
  let element = pageElements.get(manifest)
  if (!element) {
    element = () => <PluginCanvasPage manifest={manifest} />
    pageElements.set(manifest, element)
  }
  return element
}

/** Full-page routes for canvases that set `page.path`. */
export function pluginCanvasPageRoutes(canvases: PluginCanvasManifest[] = getPluginSlots().canvases): PluginAppRoute[] {
  return canvases.flatMap((manifest) =>
    manifest.page ? [{ path: manifest.page.path, element: pageElement(manifest) }] : [],
  )
}
